import React, { useRef } from "react"
import PropTypes from "prop-types"

import Container from "../../hoc/container/Container"
import IntersectionObserverWrapper from "../ioWrapper/IOWrapper"

import style from "./HeadingBlock.module.css"

const HeadingBlock = ({ index, spanColour }) => {
  const container = useRef(null)
  const isVisible = useRef(false)

  const content = [
    {
      title: (
        <>
          Your platform. <span style={{ color: spanColour }}>Your colour.</span>
        </>
      ),
      subtitle: (
        <>
          Create a personal life wheel, success system and dashboard. Style your
          app with any colour!
        </>
      ),
    },

    {
      title: <>Make Meaningful Matches</>,
      subtitle: (
        <>
          Our unique algorithm connects you with people for you to help, and
          others to help you.
        </>
      ),
    },

    {
      title: <>Team up, up and away</>,
      subtitle: (
        <>
          {/* Help each other rise to the top.
          <br /> */}
          Connect with your friends, family, coach and other members. Stay
          accountable to your goals and lift one another.
        </>
      ),
    },
  ]

  // Reveal people from our tribe who can help you, and others for you to help.

  const handleIntersection = entries => {
    if (isVisible.current) return
    const entry = entries[0]
    const intersectionRatio = entry.intersectionRatio
    if (intersectionRatio > 0.8) {
      container.current.style.transform = `translateY(0%)`
      container.current.style.opacity = 1
      isVisible.current = true
    } else {
      container.current.style.transform = `translateY(100%)`
      container.current.style.opacity = 0
    }
  }

  return (
    <IntersectionObserverWrapper
      thresholdSteps={10}
      callback={handleIntersection}
    >
      <div ref={container} className={style.container}>
        <Container>
          <h2>{content[index].title}</h2>
          <h3>{content[index].subtitle}</h3>
        </Container>
      </div>
    </IntersectionObserverWrapper>
  )
}

HeadingBlock.propTypes = {
  index: PropTypes.number.isRequired,
  containerClass: PropTypes.string,
}
// Props for which section

export default HeadingBlock
